import { QueryDocumentSnapshot, serverTimestamp, SnapshotOptions } from "firebase/firestore";
import { auth } from "../services/firebase";

/**
 * A holiday / observance imported from the dedicated "Feiertage" sheet of the
 * Predigtdienstplan workbook. Stored in its own collection so the calendar can
 * show holidays ahead of time, independent of whether a service is planned.
 */
export default class Holiday {
    date: string; // YYYY-MM-DD
    name: string;
    kuerzel: string;
    weekday: string;
    isPublicHoliday: boolean;
    year: number;
    importedBy: string;
    importedAt: Date;

    constructor(
        date: string,
        name: string,
        kuerzel: string,
        weekday: string,
        isPublicHoliday: boolean,
        importedBy: string,
        importedAt: Date
    ) {
        this.date = date;
        this.name = name;
        this.kuerzel = kuerzel;
        this.weekday = weekday;
        this.isPublicHoliday = isPublicHoliday;
        this.year = Number(date.slice(0, 4));
        this.importedBy = importedBy;
        this.importedAt = importedAt;
    }
}

export const holidayConverter = {
    toFirestore: (holiday: Holiday) => {
        // Parse the date string as UTC midnight to avoid timezone drift, matching
        // how SundayService dates are written.
        const [year, month, day] = holiday.date.split("-").map(Number);
        return {
            date: new Date(Date.UTC(year, month - 1, day)),
            dateString: holiday.date,
            name: holiday.name,
            kuerzel: holiday.kuerzel,
            weekday: holiday.weekday,
            isPublicHoliday: holiday.isPublicHoliday,
            year: holiday.year,
            importedBy: auth.currentUser?.uid ?? "",
            importedAt: serverTimestamp(),
        };
    },

    fromFirestore: (snapshot: QueryDocumentSnapshot, options: SnapshotOptions) => {
        const data = snapshot.data(options);
        return new Holiday(
            data.dateString,
            data.name,
            data.kuerzel ?? "",
            data.weekday ?? "",
            data.isPublicHoliday ?? false,
            data.importedBy ?? "",
            data.importedAt?.toDate() ?? new Date()
        );
    },
};
